/* ============================================================================
   pf-motion.js —— 入场观察器（.pf-reveal 的驱动）+ 动效降级
   ----------------------------------------------------------------------------
   设计要点：
   1) **渐进增强**：根元素上的 .pf-motion-ready 由本文件第一个加。
      CSS 的隐藏态挂在这个类下面 ⇒ 没有 JS / JS 报错 / 老浏览器 ⇒ 元素本就可见，
      **不可能出现"白屏"**。（所以永远不要把 opacity:0 直接写进 .pf-reveal。）
   2) **特性检测**：没有 IntersectionObserver 就直接返回、什么都不做（老浏览器照常显示）。
   3) **只播一次**：进入视口后 unobserve，绝不来回抖动。
   4) **同组错峰**：同一父元素下的 .pf-reveal 按顺序延迟 70ms（最多 6 档），
      用 animation-delay 实现（入场是 animation 驱动的），播完清除。
   5) **可重扫**：AJAX 渲染出来的列表（如目录页）可以调 window.pfMotionScan() 重新挂观察器。
   ============================================================================ */
(function () {
  var doc = document;
  var root = doc.documentElement;

  if (!('IntersectionObserver' in window)) { return; }

  /* ?pfm=off —— 内部对比开关：打上根属性用于 CSS 门控，并**不加** pf-motion-ready
     ⇒ 入场动效整体关闭（等价旧版）。真机 A/B 用：同一页加不加该参数对比。 */
  try {
    if (/(?:^|[?&])pfm=off(?:&|$)/.test(String(location.search || ''))) {
      root.setAttribute('data-pfm', 'off');
      return;
    }
  } catch (e) { }

  root.classList.add('pf-motion-ready');

  var STEP_MS = 90;   /* 2026-10-01 #12：70→90，节奏更明显 */
  var MAX_STEPS = 8;   /* 2026-10-01 #12：6→8，长列表也能每项错开 */
  var io = null;

  function observer() {
    if (io) { return io; }
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var en = entries[i];
        if (!en.isIntersecting) { continue; }
        var el = en.target;
        el.classList.add('pf-in');
        io.unobserve(el);
        (function (node) {
          setTimeout(function () { node.style.animationDelay = ''; }, 900);
        })(el);
      }
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    return io;
  }

  function indexInParent(el) {
    var p = el.parentNode;
    if (!p) { return 0; }
    var kids = p.children, n = 0;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i] === el) { break; }
      if (kids[i].classList && kids[i].classList.contains('pf-reveal')) { n++; }
    }
    return n;
  }

  function scan(scope) {
    var host = scope && scope.querySelectorAll ? scope : doc;
    var nodes = host.querySelectorAll('.pf-reveal:not(.pf-in)');
    if (!nodes.length) { return 0; }
    var ob = observer();
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var step = Math.min(indexInParent(el), MAX_STEPS);
      el.style.animationDelay = (step * STEP_MS) + 'ms';
      ob.observe(el);
    }
    return nodes.length;
  }

  /* 供 AJAX 列表复用 */
  window.pfMotionScan = scan;

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  /* ==========================================================================
     ⑥ 特效层驱动（2026-10-01）：#5 点击涟漪 · #10 滚动进度条
     --------------------------------------------------------------------------
     🔴 本段写在 ?pfm=off 的 `return` **之后** ⇒ 天然被门控关掉，不必再判一次。
     🔴 涟漪用 pointerdown（比 click 更早反馈，且触屏同样触发）。
     🗑 2026-10-01 22:17：#1 柔光跟随已删除；下面的 `fine` 仍被 #2 3D 倾斜使用，别一起删。
     ========================================================================== */
  (function fx() {
    var fine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* --- #5 点击涟漪（全局委托，只作用在 button / .pf-btn 上） --- */
    if (!calm) {
      doc.addEventListener('pointerdown', function (e) {
        var t = e.target;
        if (!t || !t.closest) { return; }
        var host = t.closest('button, .pf-btn');
        if (!host) { return; }
        /* 🔴 排除用「绝对定位 + translateY(-50%)」做垂直居中的箭头键：
           给它们加 overflow/position 会改变定位参照 ⇒ 按下瞬间跳位。 */
        if (host.classList.contains('twd__arrow') || host.classList.contains('twd__search-clear')) { return; }
        var cs = window.getComputedStyle(host);
        if (cs.position === 'static') { host.style.position = 'relative'; }
        if (cs.overflow === 'visible') { host.style.overflow = 'hidden'; }
        var r = host.getBoundingClientRect();
        var size = Math.max(r.width, r.height) * 2.2;
        var s = doc.createElement('span');
        s.className = 'pf-ripple';
        s.style.width = s.style.height = size + 'px';
        s.style.left = (e.clientX - r.left - size / 2) + 'px';
        s.style.top = (e.clientY - r.top - size / 2) + 'px';
        host.appendChild(s);
        setTimeout(function () { if (s.parentNode) { s.parentNode.removeChild(s); } }, 700);
      }, { passive: true });
    }

    /* --- #10 滚动进度条 + #9 hero 视差（同一个 scroll tick，每帧只写 transform/opacity） --- */
    var prog = doc.getElementById('pfProg');
    var hero = doc.querySelector('.pf-hero__inner');
    if (prog || hero) {
      var ticking = false;
      var tick = function () {
        ticking = false;
        var el = doc.documentElement;
        var h = el.scrollHeight - window.innerHeight;
        var y = window.pageYOffset || el.scrollTop || 0;
        if (prog) {
          prog.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, y / h) : 0).toFixed(4) + ')';
        }
        /* #9 hero 视差：内容随滚动缓慢上移并淡出（可逆）。
           🔴 参考量用 window.innerHeight 而不是读 hero 的 rect —— 每帧 getBoundingClientRect
              会强制同步布局（本项目明令避免）。 */
        if (hero && !calm) {
          var p = Math.min(1, y / (window.innerHeight * 0.85));
          hero.style.transform = 'translate3d(0,' + (p * 56).toFixed(1) + 'px,0)';
          hero.style.opacity = (1 - p * 0.88).toFixed(3);
        }
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(tick); }
      }, { passive: true });
      window.addEventListener('resize', tick, { passive: true });
      tick();
    }

    /* --- #2 3D 倾斜（桌面；事件委托 + 只在换卡时读一次 rect，避免每帧强制布局） --- */
    if (fine && !calm) {
      var tCur = null, tRect = null;
      var clearTilt = function () { if (tCur) { tCur.style.transform = ''; } tCur = null; tRect = null; };
      doc.addEventListener('pointermove', function (e) {
        var t = e.target;
        var el = (t && t.closest) ? t.closest('.pf-tilt') : null;
        if (el !== tCur) {
          if (tCur) { tCur.style.transform = ''; }
          tCur = el;
          tRect = el ? el.getBoundingClientRect() : null;
        }
        if (!tCur || !tRect || !tRect.width) { return; }
        var nx = (e.clientX - tRect.left) / tRect.width - 0.5;
        var ny = (e.clientY - tRect.top) / tRect.height - 0.5;
        tCur.style.transform = 'perspective(800px) rotateY(' + (nx * 9).toFixed(2) + 'deg) rotateX('
                             + (-ny * 9).toFixed(2) + 'deg) scale(1.02)';
      }, { passive: true });
      window.addEventListener('pointerleave', clearTilt);
      window.addEventListener('blur', clearTilt);
    }

    /* --- #11 数字翻滚（进入视口一次；只对带 data-pf-count 且 >0 的元素） --- */
    var counters = doc.querySelectorAll('[data-pf-count]');
    if (counters.length && 'IntersectionObserver' in window && !calm) {
      var runCount = function (el) {
        var to = parseInt(el.getAttribute('data-pf-count'), 10);
        if (!(to > 0)) { return; }
        var m = /^(\D*)(\d+)(\D*)$/.exec((el.textContent || '').trim());
        if (!m) { return; }        /* 例如 "5–10" ⇒ 解析失败，保持静态（符合预期） */
        var pre = m[1], suf = m[3], t0 = 0;
        var step = function (ts) {
          if (!t0) { t0 = ts; }
          var k = Math.min(1, (ts - t0) / 1400);
          var e2 = 1 - Math.pow(1 - k, 3);
          el.textContent = pre + Math.round(to * e2) + suf;
          if (k < 1) { requestAnimationFrame(step); }
        };
        requestAnimationFrame(step);
      };
      var ioC = new IntersectionObserver(function (es) {
        for (var i = 0; i < es.length; i++) {
          if (es[i].isIntersecting) { ioC.unobserve(es[i].target); runCount(es[i].target); }
        }
      }, { threshold: 0.6 });
      Array.prototype.forEach.call(counters, function (c) { ioC.observe(c); });
    }
  })();
})();
